<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Super Starters">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e266" xmlns:saxon="http://icl.com/saxon">Super
                            Starters</a></h1><a id="d0e266" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e266" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e266" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e266" xmlns:saxon="http://icl.com/saxon">
</a><h3 class="nodivide"><a id="d0e266" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e269" xmlns:saxon="http://icl.com/saxon">Fredrik’s Celebrated Zucchini
                Toasts</a></h3><a id="d0e269" xmlns:saxon="http://icl.com/saxon">
<p>My long-standing tennis instructor, Fredrik, is not Southern. He is Swedish. However,
                he and his French/German wife, Nadja, share a deep love of good food, especially
                fresh vegetables, seafood, and chocolate. Over the years, we’ve become friends and
                as such have shared recipe ideas—one of our most loved subjects.</p>
<p>This is my interpretation of one of Fredrik and Nadja’s favorites. They like it so
                much that they prepared it for their wedding guests. It’s such a brilliant, fresh
                twist on this prolific and delicious summer squash, I think it will become one of
                your favorites, as well. Grating, salting, and draining the zucchini helps extract
                water and concentrates the clean-tasting sweetness of the squash.</p>
</a><h4><a id="d0e269" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e275" xmlns:saxon="http://icl.com/saxon">For the topping</a></h4><a id="d0e275" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 large zucchini squash</td>
</tr>
<tr>
<td>1 teaspoon kosher or sea salt</td>
</tr>
<tr>
<td>2 tablespoons extra virgin olive oil</td>
</tr>
<tr>
<td>8 leaves fresh basil, chopped</td>
</tr>
<tr>
<td>3 cloves garlic</td>
</tr>
<tr>
<td>1 shallot, finely chopped</td>
</tr>
<tr>
<td>Salt and freshly ground pepper</td>
</tr>
</tbody></table>
</a><h4><a id="d0e275" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e292" xmlns:saxon="http://icl.com/saxon">For the toasts</a></h4><a id="d0e292" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 tablespoons butter</td>
</tr>
<tr>
<td>2 tablespoons olive oil</td>
</tr>
<tr>
<td>1 baguette French bread (or another favorite bread of choice), sliced and
                        cut on the bias into 1/4-inch-thick pieces</td>
</tr>
<tr>
<td>Salt and freshly ground pepper</td>
</tr>
</tbody></table>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1/2 cup grated or shaved Parmigiano-Reggiano (or another aged hard
                        cheese)</td>
</tr>
<tr>
<td>Fresh basil leaves or chopped tomatoes, to garnish</td>
</tr>
</tbody></table>
<p>To prepare the topping, scrub and trim the tops and bases from the zucchini. Using a
                medium-size grater, grate over a bowl. Toss with the salt and let stand 10 minutes.
                Rinse away the salt thoroughly and drain well in a colander. Shape the grated
                zucchini into tennis ball-size handfuls and squeeze out excess water; discard the
                water and return zucchini to the bowl. Toss with olive oil, basil, garlic, and
                shallot. Season with salt and pepper to taste. Cover and allow to sit for at least
                30 minutes before serving. (NOTE: The topping can be prepared up to this point and
                refrigerated, covered, for up to 24 hours.)</p>
<p>To prepare the toasts, heat a large skillet over medium-high heat. Add butter and oil
                and cook until just bubbling. Arrange bread slices in a single layer in the pan (you
                will need to do this in batches) and season generously with salt and pepper. Cook
                until golden on one side. Turn, season, and repeat. Remove the toasts from the pan
                and cool on a paper towel. (NOTE: The toasts will store, once cooled, in an airtight
                container for up to 2 days.)</p>
<p>To assemble, preheat the broiler and bring the zucchini mixture to room temperature.
                Scoop a scant tablespoon onto each prepared toast. Arrange the toasts in a single
                layer on a baking sheet. Broil on the middle rack of the oven until bubbling.
                Arrange on a platter and sprinkle each toast with the cheese and garnish with basil
                or tomato. Serve immediately. </p>
<p>Makes 16–20 servings</p>
<div class="mediaobject" title="This is a photo of Fredrik’s Celebrated Zucchini Toasts.">
<img alt="Super Starters" src="images/LMP8935.jpg"/>
</div>
</a><div class="sidebar" title="Zucchini Picking"><a id="d0e292" xmlns:saxon="http://icl.com/saxon">
<p class="title">
<b>Zucchini Picking</b>
</p>
</a><p><a id="d0e292" xmlns:saxon="http://icl.com/saxon"></a><a id="zucchini" xmlns:saxon="http://icl.com/saxon">Look for blemish-free squash that is heavy for its size. Stay away from huge
                    zucchini, as they can be stringy, bland, and tough. Use zucchini as soon as you
                    bring it home for an extra-special fresh treat. If you need to store zucchini,
                    store it loosely wrapped in plastic or cloth in the refrigerator for one to
                    three days. The same rules apply for yellow summer squash. </a></p><a id="zucchini" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="zucchini" xmlns:saxon="http://icl.com/saxon">
</a><h3><a id="zucchini" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e326" xmlns:saxon="http://icl.com/saxon">Greek-Kissed Stuffed Zucchini
                Blossoms</a></h3><a id="d0e326" xmlns:saxon="http://icl.com/saxon">
<p>It took me years of combing farmers markets and ample coaxing from multiple market
                vendors to summon the courage to work with the impossibly delicate, seductive
                flowers of zucchini squash. Like newborn babies, they frightened me with their
                seeming fragility and seamless beauty.</p>
<p>One try and I was converted. In fact, both the male and female blossoms of the
                zucchini plant are surprisingly simple to work with, assuming you use them the day
                you buy them. After that, they start wilting and become tough, which makes them
                harder to work with and robs them of their peak culinary power.</p>
<p>Chopped olives, oregano, and lemon give this recipe a touch of the sunny flavors of
                Greece, but feel free to play with this and have fun as you gain blossom
                bravado.</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>12 zucchini blossoms</td>
</tr>
<tr>
<td>1/4 cup cream cheese, at room temperature (or substitute fresh goat
                        cheese)</td>
</tr>
<tr>
<td>1/4 cup whole milk ricotta cheese</td>
</tr>
<tr>
<td>1 tablespoon half-and-half</td>
</tr>
<tr>
<td>Salt and freshly ground pepper</td>
</tr>
<tr>
<td>1 tablespoon chopped fresh parsley</td>
</tr>
<tr>
<td>1 teaspoon chopped fresh oregano</td>
</tr>
<tr>
<td>Zest of 1 lemon</td>
</tr>
<tr>
<td>2 tablespoons finely chopped pitted Greek olives</td>
</tr>
<tr>
<td>1 egg yolk</td>
</tr>
<tr>
<td>1-1/2 cups all-purpose flour</td>
</tr>
<tr>
<td>2 cups vegetable oil</td>
</tr>
</tbody></table>
<p>Gently rinse the blossoms in cool water and trim the stem length to 2 inches. Pat
                dry, very gently, with a paper towel; set aside. Using a hand mixer, whip together
                the cream cheese, ricotta, half-and-half, and salt and pepper to taste in a
                medium-size bowl until light and frothy. With a spatula, fold in the parsley,
                oregano, lemon zest, and olives. Taste and adjust seasonings if necessary. Gently
                stuff each blossom with about 2 tablespoons of the stuffing mixture, depending on
                the blossom’s size. Do not overfill! Gently twist the petals together at the top of
                the blossom to seal; set aside.</p>
<p>In a small shallow bowl, beat the egg yolk. In a second, larger shallow bowl, combine
                the flour with some salt and pepper to season. To coat each blossom, individually
                dip in the egg yolk, and then coat lightly in the flour to cover all surfaces. </p>
<p>To fry the stuffed blossoms, heat the oil to 375 degrees, lightly sizzling in a
                large, deep skillet over medium-high heat. Cook the stuffed blossoms in batches
                (about 4 at a time), gently spooning them into the oil and cooking on each side for
                about 3 minutes, or until light golden brown. Remove, drain on paper towels, and
                season very lightly with salt. Serve immediately on a platter garnished with a fresh
                zucchini blossom and/or fresh oregano. (Prediction: They’ll be gone in about 2
                minutes, so be prepared for the next course!)</p>
<p>Makes 12 servings</p>
</a><h3><a id="d0e326" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e367" xmlns:saxon="http://icl.com/saxon">Cantaloupe Balls with Prosciutto,
                Lime, and Basil</a></h3><a id="d0e367" xmlns:saxon="http://icl.com/saxon">
<p>On a hot Southern summer morning, the luscious smell of ripe cantaloupe at a farmers
                market booth will reach your nose even before your eyes fall upon the gentle fruit.
                Simple and unadulterated, the classic pairing of sweet, fragrant melon and salty
                aged ham sparkles with a fresh twist of lime and a drizzle of chopped fresh basil.
                Serve this as an appetizer to a light, midsummer evening meal. Be open to variations
                using watermelon and honeydew, which work equally well with the lime, basil, and ham
                in this recipe.</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1/2 large cantaloupe, seeded</td>
</tr>
<tr>
<td>1/2 pound prosciutto or aged ham, thinly sliced</td>
</tr>
<tr>
<td>Juice of 1/2 lime, plus juices from the cantaloupe</td>
</tr>
<tr>
<td>3 tablespoons good-quality extra virgin olive oil</td>
</tr>
<tr>
<td>Freshly ground pepper</td>
</tr>
<tr>
<td>3 tablespoons chopped fresh basil</td>
</tr>
</tbody></table>
<p>Using a mellon-baller or rounded spoon, scoop balls from the seeded half of the melon
                and then place in a bowl, reserving any of the melon’s juices. Cut the prosciutto
                into 1/4-inch-wide strips and wrap once around each melon ball. Seal the ends by
                piercing through them and the melon ball with a toothpick. Chill, covered, up to 3
                hours. Just before serving, drizzle the reserved melon juices, lime juice, oil, and
                pepper over top. Toss to coat. Arrange on an attractive serving platter and sprinkle
                with the basil. Serve cool to room temperature. </p>
<p>Makes about 40 bite-size servings</p>
<div class="mediaobject" title="This is a photo of Cantaloupe Balls with Prosciutto, Lime, and Basil.">
<img alt="Zucchini Picking" src="images/IIP6473.jpg"/>
</div>
</a><h3><a id="d0e367" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e393" xmlns:saxon="http://icl.com/saxon">WBAM! Watermelon, Bacon, Avocado,
                and Fresh Goat Cheese Sandwich Bites</a></h3><a id="d0e393" xmlns:saxon="http://icl.com/saxon">
<p>Summer absolutely sizzles in the South. Watermelon is a refreshing and popular way to
                chill out, and it takes on major taste and texture proportions in this fun twist on
                a white-bread BLT. At once crunchy, salty, sweet, cool, and creamy, this sandwich
                can be eaten in either appetizer portions or as an easy summer lunch. </p>
<p>Technically, avocados aren’t local since they’re not grown in the region, but
                watermelon, fresh bread, goat cheese, and, in some cases, bacon are readily
                available at many farmers markets. Prepare these just before serving to avoid soggy
                sandwiches. They will not sit around long—I promise. </p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 fresh French baguette, cut into four 4-inch lengths, and then halved
                        horizontally</td>
</tr>
<tr>
<td>1/4 cup olive oil</td>
</tr>
<tr>
<td>12 slices bacon</td>
</tr>
<tr>
<td>1 ripe avocado</td>
</tr>
<tr>
<td>Juice of 1/2 lime</td>
</tr>
<tr>
<td>8 ounces fresh goat cheese</td>
</tr>
<tr>
<td>Salt and freshly ground pepper</td>
</tr>
<tr>
<td>1 small, seedless watermelon, cut into 8 (1/4-inch-thick) slices and chilled
                    </td>
</tr>
<tr>
<td>16 fresh basil leaves</td>
</tr>
<tr>
<td>4 teaspoons Dijon mustard</td>
</tr>
<tr>
<td>4 teaspoons mayonnaise</td>
</tr>
</tbody></table>
<p>Preheat broiler to high. Lay the baguettes, cut-side up, on a single layer of a
                baking sheet. Drizzle evenly with the oil. Watching closely, broil on the middle
                rack of the oven until golden brown, about 5 minutes. Remove and set aside to cool.
                Meanwhile, cook the bacon in a very large sauté pan. Remove bacon from the pan and
                drain on paper towels.</p>
<p>To assemble, cut the avocado in half, remove the pit, and cut each half into 4 thick
                slices. Drizzle evenly with the lime juice. Spread one-quarter of the goat cheese on
                the bottom half of each section of toasted bread. Season each with a bit of salt and
                pepper. Arrange 3 pieces of bacon on top, followed by 2 slices watermelon, then 2
                slices avocado. Arrange 4 basil leaves on top. Slather mustard and mayonnaise in
                equal quantities on one side of each remaining slice of bread. Place on top of the
                sandwiches. To make “bites,” cut each sandwich into 4 pieces and secure by piercing
                each section with a sturdy toothpick and serve immediately.</p>
<p>Makes 16 sandwich bites (or 4 regular sandwiches)</p>
</a><h3><a id="d0e393" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e428" xmlns:saxon="http://icl.com/saxon">Butter Bean and Grape Tomato
                Bruschetta</a></h3><a id="d0e428" xmlns:saxon="http://icl.com/saxon">
<p>Butter beans have a mild flavor and a meaty texture, so they play with a virtually
                endless combination of flavors, from goat cheese to bacon. Here, I mix them with
                sprite grape tomatoes and serve on toast for a play on a classic bruschetta. For a
                fabulous salad, leave out the bruschetta toast. The flavors deepen with time, so
                prepare the bean mixture several hours ahead and assemble just before serving. Serve
                at room temperature for maximum flavor.</p>
</a><h4><a id="d0e428" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e432" xmlns:saxon="http://icl.com/saxon">For the salad</a></h4><a id="d0e432" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 cups water</td>
</tr>
<tr>
<td>3 tablespoons salt</td>
</tr>
<tr>
<td>1 cup fresh butter beans</td>
</tr>
<tr>
<td>1/4 cup good-quality extra virgin olive oil</td>
</tr>
<tr>
<td>2 cloves garlic, minced</td>
</tr>
<tr>
<td>1/4 medium red onion, finely chopped</td>
</tr>
<tr>
<td>1/2 cup quartered (lengthwise) grape tomatoes, or finely chopped regular
                        tomato</td>
</tr>
<tr>
<td>2 tablespoons red wine vinegar</td>
</tr>
<tr>
<td>2 tablespoons chopped fresh parsley</td>
</tr>
<tr>
<td>2 tablespoons chopped fresh basil</td>
</tr>
<tr>
<td>1 teaspoon finely grated lemon, orange, or lime zest</td>
</tr>
<tr>
<td>Salt and freshly ground pepper</td>
</tr>
</tbody></table>
</a><h4><a id="d0e432" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e459" xmlns:saxon="http://icl.com/saxon">For the toast</a></h4><a id="d0e459" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 country-style baguette</td>
</tr>
<tr>
<td>3 tablespoons good-quality extra virgin olive oil</td>
</tr>
<tr>
<td>Salt and freshly ground pepper</td>
</tr>
<tr>
<td>3 cloves garlic, peeled and lightly smashed</td>
</tr>
</tbody></table>
<p>Bring the water and salt to a boil in a medium pot. Add the beans, reduce heat to a
                simmer, and cook until crisp-tender, about 25 minutes depending on freshness. Drain
                in a colander, rinsing thoroughly with cold water. In a large bowl, combine the
                cooked beans with remaining salad ingredients. Season carefully and taste to verify
                seasoning. Cover and allow to marinate at room temperature up to 4 hours or
                refrigerate overnight and bring back to room temperature before serving.</p>
<p>To prepare the toast, preheat the oven to 450 degrees. Cut the baguette into
                1/4-inch-thick slices at a diagonal angle. Arrange in a single layer on a baking
                sheet. Drizzle with half of the oil, season generously with salt and pepper, turn
                over and repeat on the other side. Place in the center rack of the oven. Bake until
                golden brown, about 5 to 8 minutes, turn over and repeat, being careful not to burn
                the toast. Remove from the oven. While still warm, rub both sides of each toast with
                the smashed garlic. </p>
<p>To serve, spoon about 2 tablespoons of the butter bean salad on each warm toast.
                Arrange on a large platter and garnish with fresh parsley or basil points. Serve
                immediately.</p>
<p>NOTE: The bruschetta toast can be prepared up to one day in advance, cooled and
                stored in an airtight container. To “crisp” the toasts, reheat in a 450-degree oven
                for just a few minutes and serve as outlined above.</p>
<p>Makes about 16-20 servings</p>
</a><h3><a id="d0e459" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e480" xmlns:saxon="http://icl.com/saxon">Roasted Guinea Eggplant and
                Garlic Dip</a></h3><a id="d0e480" xmlns:saxon="http://icl.com/saxon">
<p>The Guinea squash—the deep purple-to-black, large, traditional eggplant—is
                significantly more bitter than the sweet and tender varieties such as Japanese,
                zebra, and neon eggplants that grace Southern farmers markets from summer through
                the first frost of fall. That is why it is a perfect candidate for roasting, which
                sweetens the flesh and makes for easy bitter-skin removal after it’s out of the
                oven.</p>
<p>This is a delicious, nutritious low-calorie dish that makes use of eggplant’s natural
                tendency to soak up just about anything as readily as a six-year-old soaks up
                knowledge and bad words. In this case, the eggplant is exposed to heaping doses of
                sweet roasted garlic, yogurt, fruity olive oil, and lemon. </p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 medium-size Guinea eggplants</td>
</tr>
<tr>
<td>1 head garlic</td>
</tr>
<tr>
<td>Juice of 1 lemon</td>
</tr>
<tr>
<td>3 tablespoons chopped fresh parsley</td>
</tr>
<tr>
<td>1/4 cup plain yogurt</td>
</tr>
<tr>
<td>1/4 cup extra virgin olive oil</td>
</tr>
<tr>
<td>Dash hot pepper flakes</td>
</tr>
<tr>
<td>Salt and freshly ground pepper</td>
</tr>
</tbody></table>
<p>Preheat oven to 425 degrees. Slice the eggplants in half vertically and arrange them,
                cut-side down, on a roasting pan. Trim the papery top of the garlic, drizzle with a
                dash of olive oil and wrap tightly with foil. Place on the roasting pan beside the
                eggplant. Roast until the eggplant has softened and collapsed upon itself and the
                garlic is tender to the touch; about 25 minutes. Set both aside until they’re cool
                enough to handle, about 15 minutes.</p>
<p>Cup one eggplant half in your free hand and scoop the soft, juicy flesh away from the
                skin, reserving any juices. Repeat with other half and place the flesh and juices
                into the bowl of a food processor fitted with a steel blade. Squeeze the garlic
                cloves free from the skins of the entire head and add directly to the food processor
                bowl, discarding any papery skins. Add lemon juice, parsley, and yogurt and pulse
                until smooth, about 10 times. While the machine is running, gradually incorporate
                the olive oil in a steady, thin stream. Add the hot pepper flakes, salt, and pepper;
                pulse to incorporate.</p>
<p>Refrigerate mixture overnight. Allow the dip to come to room temperature before
                serving and arrange in a pretty bowl surrounded by toasted pita bread wedges. </p>
<p>Makes 8–12 servings</p>
<div class="mediaobject" title="This is a photo of Roasted Guinea Eggplant and Garlic Dip.">
<img alt="Zucchini Picking" src="images/IIP6488.jpg"/>
</div>
</a><h3><a id="d0e480" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e516" xmlns:saxon="http://icl.com/saxon">Chow-Chow Deviled White Shrimp
                and Farm Fresh Eggs</a></h3><a id="d0e516" xmlns:saxon="http://icl.com/saxon">
<p>This is the consummate fall farmers market dish and it’s oh-so Southern and oh-so
                good. From September through December, the waters off Charleston, Savannah, and
                Beaufort are teeming with milky, sweet white shrimp. Many argue that the white
                shrimp’s flavor is nuttier than its summer brown shrimp counterpart and the texture
                is decidedly meatier. Of course, you could substitute brown shrimp, but the extra
                sweetness of white shrimp works especially well with the rich yolk flavor of fresh
                eggs and the tangy bite of chow-chow. When lovingly combined, these ingredients will
                render this recipe a favorite in your crowd-pleaser cooking arsenal. It is
                definitely a favorite of mine. </p>
</a><h4><a id="d0e516" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e520" xmlns:saxon="http://icl.com/saxon">To cook the eggs</a></h4><a id="d0e520" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>6 fresh eggs, at room temperature</td>
</tr>
<tr>
<td>Water to cover</td>
</tr>
</tbody></table>
</a><h4><a id="d0e520" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e527" xmlns:saxon="http://icl.com/saxon">To cook the shrimp</a></h4><a id="d0e527" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>10 to 12 white shrimp, shells on</td>
</tr>
<tr>
<td>3 sprigs fresh thyme</td>
</tr>
<tr>
<td>1 bay leaf</td>
</tr>
<tr>
<td>1 tablespoon salt</td>
</tr>
<tr>
<td>1/4 cup good-quality dry white wine</td>
</tr>
<tr>
<td>Water to cover</td>
</tr>
</tbody></table>
</a><h4><a id="d0e527" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e542" xmlns:saxon="http://icl.com/saxon">For the filling</a></h4><a id="d0e542" xmlns:saxon="http://icl.com/saxon">
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>Reserved yolks from the cooked eggs</td>
</tr>
<tr>
<td>2 tablespoons chow-chow (look for a locally canned variety at your farmers
                        market)</td>
</tr>
<tr>
<td>Dash of red wine vinegar</td>
</tr>
<tr>
<td>1 tablespoon mayonnaise</td>
</tr>
<tr>
<td>1/2 teaspoon Dijon mustard</td>
</tr>
<tr>
<td>Salt and freshly ground pepper</td>
</tr>
<tr>
<td>10 chives, cut into 1/2-inch lengths, to garnish</td>
</tr>
</tbody></table>
<p>Place the eggs in a single layer in a medium-size pot. Cover with tepid tap water.
                Bring the water to a boil over high heat. Once boiling, remove the pan from the
                heat, cover, and allow the eggs to sit in the hot water for exactly 17 minutes.</p>
<p>Meanwhile, in a deep skillet, prepare the shrimp. Combine the shrimp, thyme, bay
                leaf, salt, wine, and enough water to cover. Bring to a boil over high heat, reduce
                to a simmer, and cook until the shrimp are just opaque in the center, about 3
                minutes; drain. When cool enough to handle, peel and discard the shells. Coarsely
                chop eight of the shrimp; cut the other shrimp into 1/2-inch lengths to garnish the
                top of the eggs; set both aside. </p>
<p>After the eggs have stood in the water for a full 17 minutes, remove them from the
                water (but don’t pour the water out), and transfer the eggs to a bowl of ice water.
                Chill for 2 minutes. Put the eggs back in cooking water and bring the cooking water
                up to a boil for 10 seconds; then return the eggs to the ice water. Chill for 15
                minutes before peeling.</p>
<p>Once they have chilled, peel the eggs and cut each in half lengthwise. Carefully
                scoop out the yolks, smashing and blending them thoroughly with a fork in a small
                bowl. Set aside the egg white halves. </p>
<p>Whisk all the remaining filling ingredients except the shrimp and chives into the egg
                yolks. Taste carefully to verify seasoning. Fold in the chopped shrimp. Scoop a
                generous tablespoon of filling into each egg-white half, topping each with reserved
                shrimp pieces and 3 to 4 chive cuttings for garnish. Chill and serve within several
                hours.</p>
<p>(This recipe was originally published in the September/October 2006 edition of <span class="emphasis">
<em>Lowcountry Living Magazine</em>
</span>).</p>
<p>Serves 12</p>
<div class="mediaobject" title="This is a photo of Chow-Chow Deviled White Shrimp and Farm Fresh Eggs.">
<img alt="Zucchini Picking" src="images/LMP8988.jpg"/>
</div>
<div class="sidebar" title="Egg Timer">
<p class="title">
<b>Egg Timer</b>
</p>
<p>The reason for the apparently complicated cooking time and
                    chilling/heating/chilling process for the eggs, which I borrowed from Julia
                    Child, is two-fold and well worth the effort. First, it prevents the ugly gray
                    hue that can form around the cooked yolk if it is overcooked. More importantly,
                    the expansion and contraction process makes peeling fresh eggs, and all eggs for
                    that matter, much less troublesome. </p>
<div class="mediaobject" title="This is a photo of eggs.">
<img alt="Egg Timer" src="images/LMP8917.jpg"/>
</div>
</div>
<div class="sidebar" title="The Scoop on Chow-Chow">
<p class="title">
<b>The Scoop on Chow-Chow </b>
</p>
<p>Depending on who you ask or to which food history source you reference, chow-chow
                    originally came to this country via trades with China (some sources also include
                    India). The name is of Chinese descent and refers to the combination of
                    different mixtures of foods. In time, this became a motley and varied
                    combination of vegetables, from cabbage to cukes to zucchini, which were packed
                    together as a kind of sweet pickled relish. Similarly, in the South, a wide
                    variety of vegetables are used, though cabbage is often a prominent player.
                    Served on hot dogs and burgers or folded into chicken or tuna salad, it gives
                    original zing, sweetness, and sometimes heat (not unlike the Korean version
                    called kimchee) to anything with which it’s mixed. A Southern staple, variations
                    on chow-chow can be found at most farmers markets throughout the Southeast.
                    Sample them widely to find your personal favorite. It’s great to have some
                    at-the-ready in your larder.</p>
</div>
<div class="sidebar" title="Go Wild for American Shrimp!">
<p class="title">
<b>Go Wild for American Shrimp! </b>
</p>
<p>Close to 85 percent of the shrimp consumed in this country is imported, the bulk
                    of it pond-raised. Initiatives such as Certified Wild American Shrimp are
                    helping to get local, wild shrimp from the waters of North Carolina, South
                    Carolina, Georgia, Florida, Alabama, Mississippi, Louisiana, and Texas to our
                    tables, restaurants and farmers markets, all the while promoting sustainability,
                    preserving freshness, and protecting a sacred Southern culinary and cultural
                    tradition. </p>
<p>Equally important, the taste of wild, local Southern shrimp is incomparable and
                    unmistakable. Sweet, nutty, salty, with all kinds of variations depending on the
                    type of shrimp and the season (which varies by state), it’s light years removed
                    from the bland, watery-palate wasteland of most imported shrimp. </p>
<p>Shrimp (and other local seafood) seasons vary by state. Here’s what’s local and
                    where, according to Wild American Shrimp, Inc.:</p>
<p><span class="emphasis">
<em>White Shrimp:</em>
</span> Flourish in brackish waters and estuaries and feed on crustaceans and
                    seaweed, yielding a sweet, distinct flavor.</p>
<p><span class="emphasis">
<em>Brown Shrimp:</em>
</span> Found along salt marshes and mud bottoms of the Atlantic and Gulf coasts
                    and feed on kelp. Their flavor is salty, like the sea, and potent.</p>
<p><span class="emphasis">
<em>Pink Shrimp:</em>
</span> The most delicate of the local Southern shrimp trifecta, these rosy
                    crustaceans are prolific near Florida and the Gulf coast. </p>
</div>
</a><h3><a id="d0e542" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e617" xmlns:saxon="http://icl.com/saxon">Hot and Happy Holiday Cider</a></h3><a id="d0e617" xmlns:saxon="http://icl.com/saxon">
<p>You either love eggnog or you hate it. I hate it, with or without rum. For me, it’s
                too cloying, too sweet, too rich—not to mention fattening. However, put on a pot of
                fresh cider—free of added sugar, preservatives, and water—to simmer with cinnamon
                and some citrus and you’ve got instant Christmas and a refreshing alternative for an
                alcohol-free holiday (or anytime) libation.</p>
<p>Fresh ciders can be found in myriad flavors (I’ve encountered apple, peach, Black
                Bing cherry) throughout the farmers market season. Start simmering the cider about
                an hour before your guests arrive, as it will fill the house with an inviting, happy
                aroma that sets the stage for a good time to be had by all. If you prefer to lighten
                things up with a bit of booze, a splash of vodka is delicious, too.</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 liters fresh cider (Black Bing cherry, apple, peach—your choice)</td>
</tr>
<tr>
<td>1 orange, thinly sliced and seeds removed</td>
</tr>
<tr>
<td>1 lemon, thinly sliced and seeds removed</td>
</tr>
<tr>
<td>1 cinnamon stick</td>
</tr>
<tr>
<td>3 or 4 cloves</td>
</tr>
</tbody></table>
<p>Combine all the ingredients in a large pot. Bring to a boil over high heat. Reduce to
                low and simmer until the citrus slices have softened and the mixture is fragrant,
                about 45 minutes. Serve hot in an attractive punch bowl and ladle into mugs. Best
                consumed in front of a blazing fire on a chilly night!</p>
<p>Serves 8–12</p>
<div class="mediaobject" title="This is a photo of Hot and Happy Holiday Cider.">
<img alt="Go Wild for American Shrimp!" src="images/LMP9609.jpg"/>
</div>
</a></div><a id="d0e617" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03.vue?d8d8aa8c